import styles from "./Home.module.css";
import { Button, Flex, MultiButton } from 'components/hulam_platform'
// ..
import logo1 from "assets/images/logos/logo-1.jpg";
import logo2 from "assets/images/logos/logo-2.jpg";
import logo3 from "assets/images/logos/logo-3.jpg";
import logo4 from "assets/images/logos/logo-4.jpg";
import logo5 from "assets/images/logos/logo-5.jpg";
import logo7 from "assets/images/logos/logo-7.jpg";
import logo8 from "assets/images/logos/logo-8.jpg";

import item1 from "assets/images/main/main_item_1.jpg";
import item2 from "assets/images/main/main_contract_img.png";
import item3_1 from "assets/images/main/main_item_3_1.png";
import item3_2 from "assets/images/main/main_item_3_2.png";
import sub1 from "assets/images/main/sub1.svg";
import sub2 from "assets/images/main/sub2.svg";
import sub3 from "assets/images/main/sub3.svg";
import sub4 from "assets/images/main/sub4.svg";
import sub5 from "assets/images/main/sub5.svg";
import sub6 from "assets/images/main/sub6.svg";
import { Divider, Layout, Space } from "antd";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Parallax } from "react-parallax";

const logoList = [
  {
    key: 1,
    name: "노무법인 휴램프로",
    image: logo1
  },
  {
    key: 2,
    name: "노무법인 서린",
    image: logo2
  },
  {
    key: 3,
    name: "노무법인 사람",
    image: logo3
  },
  {
    key: 4,
    name: "노무법인 주도",
    image: logo4
  },
  {
    key: 5,
    name: "노무법인 피플",
    image: logo5
  },
  {
    key: 7,
    name: "노무법인 완성",
    image: logo7
  },
  {
    key: 8,
    name: "노무법인 리담",
    image: logo8
  },
  {
    key: 9,
    name: "노무법인 휴램프로",
    image: logo1
  },
  {
    key: 10,
    name: "노무법인 서린",
    image: logo2
  },
  {
    key: 11,
    name: "노무법인 사람",
    image: logo3
  },
  {
    key: 12,
    name: "노무법인 주도",
    image: logo4
  },
  {
    key: 13,
    name: "노무법인 피플",
    image: logo5
  },
  {
    key: 15,
    name: "노무법인 완성",
    image: logo7
  },
  {
    key: 16,
    name: "노무법인 리담",
    image: logo8
  },
  {
    key: 17,
    name: "노무법인 휴램프로",
    image: logo1
  },
  {
    key: 18,
    name: "노무법인 서린",
    image: logo2
  },
  {
    key: 19,
    name: "노무법인 사람",
    image: logo3
  },
  {
    key: 20,
    name: "노무법인 주도",
    image: logo4
  },
  {
    key: 21,
    name: "노무법인 피플",
    image: logo5
  },
  {
    key: 23,
    name: "노무법인 완성",
    image: logo7
  },
  {
    key: 24,
    name: "노무법인 리담",
    image: logo8
  },
]

export const Home = () => {
  AOS.init({
    once: true
  });

  return (
    <Layout className={styles.main_container} style={{ padding: "100px 0 0 0", background: "#fff" }}>
      <div className={styles.title_box}>
        <h2>
          급여 아웃소싱의 혁신<br />
          휴램프로에서 <span>관리 사업장을 3배</span> 늘려보세요!
        </h2>
        <MultiButton className={styles.btn_wrap}>
          <Button size="large" href="/join" width={260}>무료로 시작하기</Button>
          <Button size="large" type="line-purple" href="/login" width={260}>로그인</Button>
        </MultiButton>
      </div>
      <div className={styles.logo_container}>
        <ul className={styles.logo_container_top}>
          {logoList.map(item => {
            return (
              <li className={styles.logo_item} key={item.key}>
                <img src={item.image} alt={item.name} width={240} />
              </li>
            )
          })}
        </ul>
      </div>
      <Space className={styles.count_container} wrap style={{ gap: 60 }}>
        <div className={styles.count_item_box}>
          <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.8309 44.0786C20.8286 44.0786 20.8267 44.0767 20.8267 44.0743V43.7946C20.8267 43.6377 20.9538 43.5106 21.1107 43.5106H37.464C38.0163 43.5106 38.464 43.0629 38.464 42.5106V13.1055C38.464 12.5532 38.0163 12.1055 37.464 12.1055H9.27344C8.72115 12.1055 8.27344 12.5532 8.27344 13.1055V44.0786C8.27344 47.4294 10.2228 50.3203 13.0171 51.6061C13.1401 51.6628 13.2746 51.6895 13.4101 51.6895H15.6985C15.834 51.6895 15.9685 51.6628 16.0915 51.6061C18.8846 50.3209 20.8335 47.4318 20.8352 44.0828C20.8352 44.0805 20.8333 44.0786 20.8309 44.0786Z" fill="#E7E2FB" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.27344 13.1055C7.27344 12.0009 8.16887 11.1055 9.27344 11.1055H37.464C38.5686 11.1055 39.464 12.0009 39.464 13.1055V42.5106C39.464 43.6151 38.5686 44.5106 37.464 44.5106H21.8255C21.6652 48.0701 19.535 51.1224 16.5096 52.5146C16.2436 52.637 15.9647 52.6895 15.6985 52.6895H13.4101C13.1439 52.6895 12.865 52.637 12.599 52.5146C9.45187 51.0664 7.27344 47.8219 7.27344 44.0786V13.1055ZM37.464 13.1055H9.27344V44.0786C9.27344 47.0298 10.9854 49.562 13.4174 50.6895H15.6912C18.0903 49.5773 19.7887 47.098 19.8342 44.1981C19.8292 44.1575 19.8267 44.1162 19.8267 44.0743V43.7946C19.8267 43.0854 20.4015 42.5106 21.1107 42.5106H37.464V13.1055Z" fill="#1A1818" />
            <path d="M38.4531 51.6897H38.7825C38.918 51.6897 39.0525 51.6629 39.1755 51.6063C41.9698 50.3205 43.9192 47.4296 43.9192 44.0787C43.9192 43.765 43.6649 43.5107 43.3512 43.5107H38.4531" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M38.4531 42.5107H43.3512C44.2172 42.5107 44.9192 43.2128 44.9192 44.0787C44.9192 47.822 42.7407 51.0666 39.5936 52.5147C39.3276 52.6371 39.0487 52.6897 38.7825 52.6897H38.4531V50.6897H38.7752C41.0877 49.6176 42.7491 47.2755 42.9069 44.5107H38.4531V42.5107Z" fill="#1A1818" />
            <path d="M38.4547 43.5105H21.3938C21.0802 43.5105 20.8259 43.7648 20.8259 44.0785C20.8259 45.7317 20.3513 47.273 19.5349 48.5648C18.954 49.484 19.6776 51.6895 20.765 51.6895H38.4547" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M19.826 43.5105C19.826 42.9582 20.2737 42.5105 20.826 42.5105H38.4548V44.5105H21.8163C21.7077 46.9226 20.6945 49.1019 19.1109 50.6895H38.4548V52.6895H15.8946C15.4199 52.6895 15.0106 52.3556 14.9151 51.8906C14.8196 51.4255 15.0642 50.9574 15.5006 50.7704C18.0281 49.6868 19.826 47.1029 19.826 44.0785V43.5105Z" fill="#1A1818" />
            <circle cx="42" cy="26" r="9" fill="white" stroke="#1A1818" strokeWidth="2" />
            <path d="M42.0659 22.0019C41.7033 22.0019 41.4396 22.1789 41.3187 22.6656L40.6593 25.2985H39.4615L38.8352 22.4775C38.7363 22.0461 38.3956 21.9465 38.0659 22.024C37.7033 22.1014 37.4945 22.378 37.5934 22.7873L38.2088 25.2985H37.3187C37.0989 25.2985 37 25.4755 37 25.6967C37 25.9069 37.0989 26.0839 37.3187 26.0839H38.3956L39.1978 29.3252C39.3077 29.823 39.6374 30 39.9451 30C40.2527 30 40.5824 29.823 40.7033 29.3363L41.5165 26.0839H42.5714L43.3187 29.3141C43.4396 29.823 43.7582 30 44.0659 30C44.3736 30 44.6923 29.823 44.8132 29.3363L45.6154 26.0839H46.6813C46.9011 26.0839 47 25.9069 47 25.6967C47 25.4755 46.9011 25.2985 46.6813 25.2985H45.8022L46.4286 22.7873C46.5275 22.378 46.3187 22.1014 45.967 22.024C45.6484 21.9576 45.2967 22.0793 45.2088 22.4775L44.5824 25.2985H43.4286L42.8132 22.6656C42.6923 22.1789 42.4066 22.0019 42.0659 22.0019ZM39.6374 26.0839H40.4615L40.022 27.8318L39.6374 26.0839ZM43.6154 26.0839H44.4066L44.022 27.8207L43.6154 26.0839ZM42.0659 23.9046L42.3846 25.2985H41.7143L42.0659 23.9046Z" fill="#1A1818" />
          </svg>
          <div>
            <span className={styles.count}>14,000 <span>+</span></span>
            <p className={styles.count_item_title}>근로계약서 작성</p>
          </div>
        </div>
        <div className={styles.count_item_box}>
          <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.51652 8.36635C9.40959 8.35705 9.30153 8.35705 9.1946 8.36635C5.60809 8.67809 2.81135 11.7128 2.80878 15.4075C2.80875 15.4526 2.81172 15.4971 2.81751 15.5408V16.7623C2.81751 17.8669 3.71294 18.7623 4.81751 18.7623H13.9023C15.0069 18.7623 15.9023 17.8669 15.9023 16.7623V15.4126C15.9023 11.7156 13.1047 8.67823 9.51652 8.36635ZM9.35556 10.3599C11.8928 10.5868 13.9023 12.7457 13.9023 15.4126V16.7623H4.81751V15.417C4.81751 15.3755 4.81499 15.3345 4.8101 15.2943C4.86848 12.6821 6.8559 10.5835 9.35556 10.3599Z" fill="#1A1818" />
            <path d="M9.35501 9.35668C10.5 9.35668 11.5 9.33008 11.6485 9.33008H35.6913C39.0019 9.33008 41.6836 12.0522 41.6836 15.4127L41.5999 38.2414C41.5979 38.7922 41.1508 39.2377 40.5999 39.2377H29.4936C28.9413 39.2377 28.4936 39.6854 28.4936 40.2377V41.5874C28.4936 44.4029 26.6027 46.7681 24.0353 47.4571C23.9171 47.4888 23.925 47.67 24.0474 47.67H20.7893C17.4787 47.67 14.797 44.9479 14.797 41.5874L14.8843 17.7624V15.4127C14.8843 12.2029 12.4472 9.58721 9.34628 9.35668H9.35501Z" fill="#E7E2FB" />
            <path fillRule="evenodd" clipRule="evenodd" d="M42.6836 15.4127C42.6836 11.5141 39.5683 8.33008 35.6913 8.33008H9.80051C9.65862 8.33008 9.47234 8.34478 9.36555 8.3532C9.34517 8.35481 9.32768 8.35619 9.31395 8.35719C8.79084 8.37383 8.36652 8.79291 8.34697 9.31958C8.32702 9.85706 8.73577 10.3141 9.27214 10.3539C11.8425 10.545 13.8843 12.7178 13.8843 15.4127V17.7624L13.797 41.5874C13.797 45.4861 16.9123 48.67 20.7893 48.67H24.0474C24.3871 48.67 24.6871 48.5008 24.8679 48.242C27.5708 47.2578 29.4936 44.6474 29.4936 41.5874L29.4936 40.2377H40.5999C41.7016 40.2377 42.5958 39.3468 42.5999 38.2451L42.6836 15.4164L42.6836 15.4127ZM23.4002 46.67H20.7893C18.0455 46.67 15.7978 44.4106 15.797 41.589C15.797 41.5884 15.797 41.5879 15.797 41.5874L15.8843 17.7661L15.8843 17.7624V15.4127C15.8843 13.4192 15.073 11.6166 13.7621 10.3301H35.6913C38.435 10.3301 40.6827 12.5894 40.6836 15.4109C40.6836 15.4115 40.6836 15.4121 40.6836 15.4127L40.5999 38.2377H29.4936C28.389 38.2377 27.4936 39.1332 27.4936 40.2377V41.5874C27.4936 43.9463 25.9106 45.9185 23.7762 46.4912C23.6305 46.5303 23.5055 46.5924 23.4002 46.67Z" fill="#1A1818" />
            <path d="M28.489 41.587C28.4866 41.587 28.4847 41.585 28.4847 41.5826V40.2373C28.4847 39.685 28.9324 39.2373 29.4847 39.2373H52.1875C52.7398 39.2373 53.1875 39.685 53.1875 40.2373V41.587C53.1875 44.8854 50.6106 47.5632 47.3874 47.6607C47.4485 47.6607 47.5097 47.6696 47.5708 47.6696H24.0472C23.9248 47.6696 23.9169 47.4884 24.0351 47.4566C26.6012 46.7681 28.4914 44.405 28.4934 41.5914C28.4934 41.589 28.4914 41.587 28.489 41.587Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M54.1875 40.2373C54.1875 39.1327 53.2921 38.2373 52.1875 38.2373L52.1875 41.587C52.1875 44.3575 50.0277 46.5804 47.3572 46.6612C47.3223 46.6623 47.2878 46.6651 47.2539 46.6696H27.3612C28.6763 45.3842 29.492 43.5835 29.4934 41.5921C29.4934 41.547 29.4905 41.5025 29.4847 41.4588V40.2373L52.1875 40.2373L52.1875 38.2373H29.4847C28.3801 38.2373 27.4847 39.1327 27.4847 40.2373V41.5826C27.4847 41.6241 27.4872 41.6651 27.4921 41.7052C27.4402 44.0115 25.8746 45.9276 23.776 46.4908C23.1787 46.6511 22.9304 47.197 22.9522 47.6258C22.9634 47.8464 23.0437 48.1035 23.2416 48.3184C23.4549 48.5499 23.749 48.6696 24.0472 48.6696H47.5708C47.6606 48.6696 47.7476 48.6578 47.8304 48.6356C51.4095 48.315 54.1875 45.2729 54.1875 41.587V40.2373Z" fill="#1A1818" />
            <path d="M28.524 21.3056C27.9582 21.3056 27.5468 21.5817 27.3582 22.3409L26.3297 26.4477H24.4611L23.484 22.0476C23.3297 21.3747 22.7982 21.2194 22.284 21.3401C21.7182 21.4609 21.3925 21.8923 21.5468 22.5307L22.5068 26.4477H21.1182C20.7754 26.4477 20.6211 26.7237 20.6211 27.0688C20.6211 27.3967 20.7754 27.6728 21.1182 27.6728H22.7982L24.0497 32.7285C24.2211 33.505 24.7354 33.7811 25.2154 33.7811C25.6954 33.7811 26.2097 33.505 26.3982 32.7458L27.6668 27.6728H29.3125L30.4782 32.7112C30.6668 33.505 31.164 33.7811 31.644 33.7811C32.124 33.7811 32.6211 33.505 32.8097 32.7458L34.0611 27.6728H35.724C36.0668 27.6728 36.2211 27.3967 36.2211 27.0688C36.2211 26.7237 36.0668 26.4477 35.724 26.4477H34.3525L35.3297 22.5307C35.484 21.8923 35.1582 21.4609 34.6097 21.3401C34.1125 21.2366 33.564 21.4264 33.4268 22.0476L32.4497 26.4477H30.6497L29.6897 22.3409C29.5011 21.5817 29.0554 21.3056 28.524 21.3056ZM24.7354 27.6728H26.0211L25.3354 30.3991L24.7354 27.6728ZM30.9411 27.6728H32.1754L31.5754 30.3818L30.9411 27.6728ZM28.524 24.2735L29.0211 26.4477H27.9754L28.524 24.2735Z" fill="#1A1818" />
          </svg>
          <div>
            <span className={styles.count}>84,000 <span>+</span></span>
            <p className={styles.count_item_title}>임금명세서 작성</p>
          </div>
        </div>
        <div className={styles.count_item_box}>
          <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.8309 44.0786C20.8286 44.0786 20.8267 44.0767 20.8267 44.0743V43.7946C20.8267 43.6377 20.9538 43.5106 21.1107 43.5106H37.464C38.0163 43.5106 38.464 43.0629 38.464 42.5106V13.1055C38.464 12.5532 38.0163 12.1055 37.464 12.1055H9.27344C8.72115 12.1055 8.27344 12.5532 8.27344 13.1055V44.0786C8.27344 47.4294 10.2228 50.3203 13.0171 51.6061C13.1401 51.6628 13.2746 51.6895 13.4101 51.6895H15.6985C15.834 51.6895 15.9685 51.6628 16.0915 51.6061C18.8846 50.3209 20.8335 47.4318 20.8352 44.0828C20.8352 44.0805 20.8333 44.0786 20.8309 44.0786Z" fill="#E7E2FB" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.27344 13.1055C7.27344 12.0009 8.16887 11.1055 9.27344 11.1055H37.464C38.5686 11.1055 39.464 12.0009 39.464 13.1055V42.5106C39.464 43.6151 38.5686 44.5106 37.464 44.5106H21.8255C21.6652 48.0701 19.535 51.1224 16.5096 52.5146C16.2436 52.637 15.9647 52.6895 15.6985 52.6895H13.4101C13.1439 52.6895 12.865 52.637 12.599 52.5146C9.45187 51.0664 7.27344 47.8219 7.27344 44.0786V13.1055ZM37.464 13.1055H9.27344V44.0786C9.27344 47.0298 10.9854 49.562 13.4174 50.6895H15.6912C18.0903 49.5773 19.7887 47.098 19.8342 44.1981C19.8292 44.1575 19.8267 44.1162 19.8267 44.0743V43.7946C19.8267 43.0854 20.4015 42.5106 21.1107 42.5106H37.464V13.1055Z" fill="#1A1818" />
            <path d="M38.4531 51.6897H38.7825C38.918 51.6897 39.0525 51.6629 39.1755 51.6063C41.9698 50.3205 43.9192 47.4296 43.9192 44.0787C43.9192 43.765 43.6649 43.5107 43.3512 43.5107H38.4531" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M38.4531 42.5107H43.3512C44.2172 42.5107 44.9192 43.2128 44.9192 44.0787C44.9192 47.822 42.7407 51.0666 39.5936 52.5147C39.3276 52.6371 39.0487 52.6897 38.7825 52.6897H38.4531V50.6897H38.7752C41.0877 49.6176 42.7491 47.2755 42.9069 44.5107H38.4531V42.5107Z" fill="#1A1818" />
            <path d="M38.4547 43.5105H21.3938C21.0802 43.5105 20.8259 43.7648 20.8259 44.0785C20.8259 45.7317 20.3513 47.273 19.5349 48.5648C18.954 49.484 19.6776 51.6895 20.765 51.6895H38.4547" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M19.826 43.5105C19.826 42.9582 20.2737 42.5105 20.826 42.5105H38.4548V44.5105H21.8163C21.7077 46.9226 20.6945 49.1019 19.1109 50.6895H38.4548V52.6895H15.8946C15.4199 52.6895 15.0106 52.3556 14.9151 51.8906C14.8196 51.4255 15.0642 50.9574 15.5006 50.7704C18.0281 49.6868 19.826 47.1029 19.826 44.0785V43.5105Z" fill="#1A1818" />
            <path d="M48.7184 4.31055H30C29.4477 4.31055 29 4.75826 29 5.31055V30.1106C29 30.6629 29.4477 31.1106 30 31.1106H48.7184C49.2707 31.1106 49.7184 30.6629 49.7184 30.1106V5.31055C49.7184 4.75826 49.2707 4.31055 48.7184 4.31055Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M28 5.31055C28 4.20598 28.8954 3.31055 30 3.31055H48.7184C49.8229 3.31055 50.7184 4.20598 50.7184 5.31055V30.1106C50.7184 31.2152 49.8229 32.1106 48.7184 32.1106H30C28.8954 32.1106 28 31.2152 28 30.1106V5.31055ZM48.7184 5.31055H30V30.1106L48.7184 30.1106L48.7184 5.31055Z" fill="#1A1818" />
            <path d="M41.9199 14.823C41.9199 16.326 40.7402 17.5406 39.2803 17.5406C37.8204 17.5406 36.6406 16.326 36.6406 14.823C36.6406 13.3201 37.8204 12.1055 39.2803 12.1055C40.7402 12.1055 41.9199 13.3201 41.9199 14.823Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M39.2803 13.1055C38.3999 13.1055 37.6406 13.8447 37.6406 14.823C37.6406 15.8014 38.3999 16.5406 39.2803 16.5406C40.1607 16.5406 40.9199 15.8014 40.9199 14.823C40.9199 13.8447 40.1607 13.1055 39.2803 13.1055ZM35.6406 14.823C35.6406 12.7954 37.2409 11.1055 39.2803 11.1055C41.3197 11.1055 42.9199 12.7954 42.9199 14.823C42.9199 16.8507 41.3197 18.5406 39.2803 18.5406C37.2409 18.5406 35.6406 16.8507 35.6406 14.823Z" fill="#1A1818" />
            <path d="M42.8026 21.298C42.8026 19.2969 41.2239 17.6716 39.2802 17.6716C37.3365 17.6716 35.7578 19.2969 35.7578 21.298V23.2428C35.7578 23.795 36.2055 24.2428 36.7578 24.2428H41.8026C42.3548 24.2428 42.8026 23.795 42.8026 23.2428V21.298Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M34.7578 21.298C34.7578 18.7723 36.757 16.6716 39.2802 16.6716C41.8034 16.6716 43.8026 18.7723 43.8026 21.298V23.2428C43.8026 24.3473 42.9071 25.2428 41.8026 25.2428H36.7578C35.6532 25.2428 34.7578 24.3473 34.7578 23.2428L41.8026 23.2428V21.298C41.8026 19.8216 40.6444 18.6716 39.2802 18.6716C37.916 18.6716 36.7578 19.8216 36.7578 21.298V23.2428L34.7578 23.2428V21.298Z" fill="#1A1818" />
          </svg>
          <div>
            <span className={styles.count}>17,000 <span>+</span></span>
            <p className={styles.count_item_title}>근로계약서 작성</p>
          </div>
        </div>
      </Space>
      <Space className={styles.main_item_container} direction="vertical">
        <h2>
          지금 4대 보험료 자동 조회로<br />
          페이롤 작업 3배 단축을 경험해 보세요.
        </h2>
        <p className={styles.title_content}>
          건강보험 EDI, 국민연금 EDI, 고용산재 Total에서 자동으로 보험료를 가져옵니다.
        </p>
        <Swiper
          slidesPerView={2}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className={styles.main_item1_swiper}
          parallax
          centeredSlides
        >
          <Parallax
            bgImage={item1}
            strength={60}
            className={styles.main_item1_background}
          />
          <SwiperSlide className={styles.main_item1_slide} data-aos="fade-up" data-aos-delay="100"/>
          <SwiperSlide className={styles.main_item1_slide} data-aos="fade-up" />
          <SwiperSlide className={styles.main_item1_slide} data-aos="fade-up" data-aos-delay="200"/>
        </Swiper>
      </Space>
      <Space className={styles.main_item_container} direction="vertical" style={{ paddingBottom: 0 }}>
        <h2>
          ERP 1위 더존에서도<br />
          휴램프로의 근로계약서 솔루션을 사용합니다.
        </h2>
        <p className={styles.title_content}>
          건강보험 EDI, 국민연금 EDI, 고용산재 Total에서 자동으로 보험료를 가져옵니다.
        </p>
        <Swiper
          slidesPerView={2}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className={styles.main_item2_swiper}
          parallax
          centeredSlides
        >
          <Parallax
            bgImage={item2}
            strength={60}
            className={styles.main_item2_background}
          />
          <SwiperSlide className={styles.main_item2_slide} data-aos="fade-up"/>
          <SwiperSlide className={styles.main_item2_slide} data-aos="fade-up" data-aos-delay="200"/>
          <SwiperSlide className={styles.main_item2_slide} data-aos="fade-up" data-aos-delay="300"/>
          <SwiperSlide className={styles.main_item2_slide} data-aos="fade-up" data-aos-delay="100"/>
        </Swiper>
      </Space>

      <Space className={styles.main_item_container_2_wrapper} direction="vertical" style={{ background: "#F5F5F5" }}>
        <div className={styles.main_item_container_2}>
          <h2>
            Why? 휴램프로?<br />
            휴램프로를 사용해야 하는 이유!
          </h2>
          <Flex alignItems="center" className={styles.why_item_container} rowGap={60} style={{ marginTop: 60 }}>
            <Flex direction="column" rowGap={30}>
              <img src={item3_1} alt="" style={{ height: 426 }} className={styles.why_itm_img} />
              <p className={styles.title_content} style={{ textAlign: "center" }}>
                엑셀을 통한 수임업체 관리에 어려움을 겪거나<br />타 노무 관리 솔루션의 기능이 만족스럽지 않으셨나요?
              </p>
            </Flex>
            <Flex direction="column" rowGap={30}>
              <img src={item3_2} alt="" style={{ height: 426 }} className={styles.why_itm_img} />
              <p className={styles.title_content} style={{ textAlign: "center" }}>
                휴램프로는 근로계약서부터 임금대장, 급여명세서 및 근태/연차관리까지<br />
                자동화와 지속적인 업데이트로 노무사의 관리 효율을 높입니다!
              </p>
            </Flex>
          </Flex>
        </div>
      </Space>


      <Space className={styles.main_item_container} direction="vertical">
        <h2 className={styles}>
          휴램프로의 대표 서비스 6가지
        </h2>
        <Swiper
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          style={{
            marginTop: 40,
          }}
          className={styles.service_swiper}
        >
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub6} alt="" />
              <span>임금대장</span>
              <p>
                근태/휴가 기록을 임금대장에 쉽게 반영
                사원별 임금정보 등록으로 빠른 임금대장 작성
              </p>
            </Space>
          </SwiperSlide>
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub5} alt="" />
              <span>4대 보험 조회/신고 자동화</span>
              <p>
                건강보험 고지내역, 국민연금 결정내역,
                고용보험 당월보험료, 실업급여 지원금
                근로자 고용정보현황 다운로드
              </p>
            </Space>
          </SwiperSlide>
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub2} alt="" />
              <span>임금명세서 발송</span>
              <p>
                카카오 알림톡, 이메일로 임금명세서 발송
              </p>
            </Space>
          </SwiperSlide>
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub4} alt="" />
              <span>근로계약서/전자계약</span>
              <p>
                상용직, 일용직 근로계약서 개인정보제공동의서 등 각종 계약서
                를 편리하게 전자계약
              </p>
            </Space>
          </SwiperSlide>
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub1} alt="" />
              <span>근로형태별 관리 계산</span>
              <p>
                상용직, 일용직, 단시간
              </p>
            </Space>
          </SwiperSlide>
          <SwiperSlide className={styles.service_item_slide}>
            <Space direction="vertical" className={styles.service_item}>
              <img src={sub3} alt="" />
              <span>임금계약 형태별 급여 계산</span>
              <p>
                IT업, 유통업 - 시간외 근로수당 미지급(고정OT수당 계약)병의원 - NET(세후임금) 방식 지급
              </p>
            </Space>
          </SwiperSlide>
        </Swiper>
      </Space>

      <Space direction="vertical" className={styles.footer_top_container}>
        <div className={styles.footer_top_inner}>
          <h2 className={styles.footer_title}>
            노무관리는 휴램프로, 지금 시작하세요!
          </h2>
          <MultiButton className={styles.btn_wrap}>
            <Button size="large" type="line-purple" className={styles.footer_btn_1} href="/join" width={304}>무료로 시작하기</Button>
            <Button size="large" className={styles.footer_btn_2} href="mailto:partners@hulampro.com" width={304}>도입 문의하기</Button>
          </MultiButton>
        </div>
      </Space>

      <Space direction="vertical" className={styles.footer_bottom_container} >
        <div className={styles.footer_inner}>
          <Flex className={styles.footer_top} justifyContent="space-between" alignItems="flex-start">
            <Flex className={styles.footer_logo} direction="column" alignItems="flex-start" rowGap={11} style={{ height: '100%' }}>
              <span>(주)휴램프로</span>
              <span>대표자 : 이선희</span>
            </Flex>
            <Flex direction="column" className={styles.footer_info}>
              <Flex columnGap={30} className={styles.footer_info_item}>
                <div>사업자등록번호 : 709-86-00566</div>
                <div>전화 : <a href="tel:1522-6778">1522-6778</a></div>
                <div>팩스 : 02-6944-8456</div>
                <div><a href="mailto:help@hulampro.com">이메일 : help@hulampro.com</a></div>
              </Flex>
              <Flex direction="column" rowGap={8} alignItems="flex-start">
                <div>통신판매업 신고번호 : 2022-강원춘천-0382</div>
                <div>본사 : 강원도 춘천시 남산면 버들1길 130, 복지후생동 4층 더존BI센터</div>
              </Flex>
              <Space style={{ marginTop: 50 }}>
                <a href="mailto:help@hulampro.com" className={styles.border_btn}>
                  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http:www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.82558 3.33325H11.6236C12.0727 3.33325 12.437 3.33324 12.7324 3.35621C13.037 3.37988 13.3082 3.43009 13.5607 3.55246C13.9591 3.74557 14.2854 4.05491 14.4907 4.43827C14.6182 4.67629 14.6723 4.93159 14.6983 5.21491C14.7052 5.29024 14.71 5.36296 14.7143 5.46043C14.7246 5.69787 14.7246 5.97403 14.7246 6.29442V9.70542C14.7246 10.1315 14.7246 10.4793 14.7003 10.7619C14.6752 11.0545 14.6217 11.3171 14.4907 11.5616C14.2854 11.9449 13.9591 12.2543 13.5607 12.4474C13.3082 12.5697 13.037 12.62 12.7324 12.6436C12.437 12.6666 12.0727 12.6666 11.6236 12.6666H5.82559C5.37649 12.6666 5.01221 12.6666 4.7168 12.6436C4.4122 12.62 4.14098 12.5697 3.88853 12.4474C3.49014 12.2543 3.16382 11.9449 2.95849 11.5616C2.82757 11.3171 2.77404 11.0545 2.74891 10.7619C2.72464 10.4794 2.72465 10.1315 2.72465 9.70544V6.29439C2.72465 5.97402 2.72465 5.69786 2.73496 5.46043C2.73869 5.3747 2.74254 5.3068 2.75095 5.21491C2.7769 4.93159 2.83101 4.67629 2.95849 4.43827C3.16382 4.05491 3.49014 3.74557 3.88853 3.55246C4.14098 3.43009 4.4122 3.37988 4.7168 3.35621C5.01221 3.33324 5.37648 3.33325 5.82558 3.33325ZM3.64774 6.21914C3.64773 6.25002 3.64772 6.2816 3.64772 6.3139V9.68594C3.64772 10.1362 3.6481 10.446 3.66874 10.6863C3.68889 10.9209 3.72591 11.0486 3.77608 11.1423C3.88934 11.3538 4.07138 11.528 4.29827 11.638C4.40124 11.6879 4.54036 11.7238 4.78989 11.7432C5.04444 11.763 5.37195 11.7634 5.84463 11.7634H11.6046C12.0773 11.7634 12.4048 11.763 12.6593 11.7432C12.9089 11.7238 13.048 11.6879 13.1509 11.638C13.3778 11.528 13.5599 11.3538 13.6731 11.1423C13.7233 11.0486 13.7603 10.9209 13.7805 10.6863C13.8011 10.446 13.8015 10.1362 13.8015 9.68594V6.3139C13.8015 6.2816 13.8015 6.25002 13.8015 6.21914L10.0006 8.75023C9.98102 8.76328 9.96167 8.7762 9.94254 8.78897C9.63413 8.9948 9.38402 9.16173 9.10123 9.22879C8.85387 9.28744 8.59534 9.28744 8.34799 9.22879C8.0652 9.16173 7.81508 8.9948 7.50668 8.78896C7.48755 8.7762 7.46819 8.76328 7.44859 8.75023L3.64774 6.21914ZM13.7617 5.15306L9.48128 8.00352C9.0845 8.26775 8.98179 8.32773 8.88382 8.35097C8.77934 8.37574 8.66988 8.37574 8.5654 8.35097C8.46742 8.32773 8.36472 8.26775 7.96793 8.00352L3.68749 5.15306C3.70872 5.01573 3.73876 4.92723 3.77608 4.85755C3.88934 4.64608 4.07138 4.47181 4.29827 4.36183C4.40124 4.31192 4.54036 4.27599 4.78989 4.25659C5.04444 4.23681 5.37195 4.23648 5.84463 4.23648H11.6046C12.0773 4.23648 12.4048 4.23681 12.6593 4.25659C12.9089 4.27599 13.048 4.31192 13.1509 4.36183C13.3778 4.47181 13.5599 4.64608 13.6731 4.85755C13.7105 4.92723 13.7405 5.01573 13.7617 5.15306Z" fill="white" />
                  </svg>
                  이메일 문의
                </a>
              </Space>
            </Flex>
          </Flex>
          <Flex className={styles.footer_copy_item_container} justifyContent="flex-start" alignItems="flex-start" style={{ marginTop: 20 }}>
            <p className={styles.footer_copy}>© 2024 HULAM PRO. All Right Reserved.</p>
            <Flex className={styles.last_footer} columnGap={14}>
              <div><a href="/terms/hulampro_privacy2024">개인정보처리방침</a></div>
              <Divider type="vertical" className={styles.divider} style={{ background: "#555" }}></Divider>
              <div><a href="/terms/hulampro_service2024">서비스이용약관</a></div>
              <Divider type="vertical" className={styles.divider} style={{ background: "#555" }}></Divider>
              <div><a href="mailto:partners@hulampro.com">제휴 문의</a></div>
            </Flex>
          </Flex>
        </div>
      </Space>
    </Layout>
  )
};
